export const PRICE_TRENDS_BARS_STYLES = {
  root: "w-full rounded-[16px] bg-white p-6 shadow-ticketon-card",
  header: "mb-6 flex flex-col gap-1",
  title: "text-[18px] md:text-[22px] font-bold text-ticketon-dark-blue",
  description: "text-[13px] md:text-[14px] text-ticketon-gray-600",
  list: "flex h-72 items-stretch gap-2 md:gap-3 border-b border-ticketon-light-border pb-2",
  item: "flex flex-1 min-w-0 flex-col items-center justify-end gap-1.5",
  price:
    "text-[10px] md:text-[11px] font-semibold text-ticketon-dark-gray tabular-nums",
  barTrack: "relative flex w-full flex-1 items-end justify-center",
  bar: "w-full min-h-[4px] rounded-t-md transition-[height] duration-500 ease-out",
  barByVariant: {
    default: "bg-ticketon-light-blue/70",
    min: "bg-ticketon-green",
    max: "bg-ticketon-red-alt",
  },
  month:
    "text-[11px] md:text-[12px] font-medium uppercase tracking-wide text-ticketon-gray-600",
  badge:
    "inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-semibold text-white whitespace-nowrap",
  badgeMin: "bg-ticketon-green",
  badgeMax: "bg-ticketon-red-alt",
} as const;

export const PRICE_TRENDS_BARS_MIN_HEIGHT_PCT = 8;
